export interface AppData {
	readonly clientId?: string;
	readonly apiKey?: string;
	readonly Authorization?: string;
	readonly uuid?: string;
	readonly appVersion?: string;
	readonly deviceId?: string;
}

export interface NativeIdentity {
	readonly clientId: string;
	readonly apiKey: string;
}

export interface NativeDataError {
	readonly stage: 'app-data' | 'auth' | 'storage' | 'theme';
	readonly reason: string;
}

export interface BridgeOptions {
	readonly onError: (error: NativeDataError) => void;
}

export const BRIDGE_TIMEOUT_MS = 2_000;
